import { API_CALL } from 'actions/actionConstants'
import { FETCH_MERCHANDISE_SELLERS } from 'actions/apiActionConstants'
import type { AppAction } from 'actions/types/ActionTypes'
import getMerchandiseSellers from 'api/merchandise/getMerchandiseSellers'

function fetchMerchandiseSellers(sellerIds: Array<string>): AppAction {
  return (dispatch, getState) => {
    const state = getState()
    const sellersState = state.merchandise.merchandiseSellers

    const missingIds = sellerIds.filter(id =>
      !sellersState.sellers[id] && !sellersState.fetching[id],
    )

    if (missingIds.length === 0) {
      return
    }

    dispatch({
      type: API_CALL,
      api: FETCH_MERCHANDISE_SELLERS,
      request: () => getMerchandiseSellers(missingIds),
      sellerIds: missingIds,
    })
  }
}

export default fetchMerchandiseSellers
